//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';

import Button from '@material-ui/core/Button';
//Material-ui

//Add

import PartPageTitle from './PartPageTitle';
//Dialog
//Icon



class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
    }
	}

  componentDidMount() {
    document.title = '決済完了 - パートナーズ';
  }

  render() {

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'決済完了'}
        />
        <div style={{maxWidth:'400px', margin:'auto'}}>

          <div align='center' style={{margin:'10px'}}>
            有料サービスにお申し込みいただき<br/>
            ありがとう御座います
          </div>
          <div align='center' style={{margin:'10px'}}>
            二重決済となる恐れがありますので<br/>
            ブラウザの戻る操作は行わないで下さい
          </div>

          <div align='center' style={{padding:'10px'}}>
            <Button
              variant="contained"
              color="primary"
              style={{minWidth:'240px'}}
              onClick={ () => this.props.history.push('/') }
            >
              <div style={{fontSize:'1.2em'}}>ホームに戻る</div>
            </Button>
          </div>

        </div>
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
